export default __webpack_public_path__ + "assets/unsubscribe.7267.svg";